import React from 'react';
import parse from 'html-react-parser';
import { ITekstOgBillede } from './TekstOgBillede.definition';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import ScrollIcon from '../ServiceTjek/ScrollIkon';
import { useBreakpoint } from '../../hooks/useBreakpoint';

const TekstOgBillede = ({
	reverse = false,
	billede,
	tekst,
	cta,
	tekstUnderCTA,
	billedeBaggrundsFarve,
	visScrollIkon
}: ITekstOgBillede) => {
	const { ref, inView } = useInView({
		threshold: 0.5,
		triggerOnce: true
	});
	const { breakpoint } = useBreakpoint();
	const showScrollIkon = breakpoint !== 'xs' && visScrollIkon;
	const domRef = React.useRef(null);

	const renderTextBlock = () => (
		<div className="tekst-og-billede__tekst text-center">

			<h2 className="text-center text-xl responsive mb-3">{ parse(tekst) }</h2>
			{ cta && cta.url && (
				<a
					className="button button--liv mb-1"
					href={ cta.url }
					target={ cta.target || '_self' }
				>
					{ cta.title }
				</a>
			) }
			{ tekstUnderCTA && <p className="mb-2" dangerouslySetInnerHTML={ { __html: tekstUnderCTA } } /> }
		</div>
	);


	const renderImgBlock = () => (
		<motion.div
			style={ { position: 'relative' } }
			animate={ {
				top: inView ? 0 : 50,
				opacity: inView ? 1 : 0

			} }
			transition={ { duration: .850, ease: 'easeOut' } }
			className={ ['text-center', billedeBaggrundsFarve && `billede-baggrund--${billedeBaggrundsFarve}`].join(' ') }>

			<motion.div
				style={ { position: 'relative' } }
				animate={ { top: inView ? -50 : 50, opacity: inView ? 1 : 0 } }
				transition={ { ease: 'easeOut', duration:0.85 } }
			>
				<img src={ billede.url } alt={ billede.alt || '' } className="w-75 tekst-og-billede__billede" />
			</motion.div>

		</motion.div>
	);

	return (
		<section className="servicetjek-tekst-og-billede" ref={ domRef }>
			<div className="f-grid mb" ref={ ref }>
				<div
					className={ `col-sm-4 ${
						reverse ? 'reverse' : ''
					} col-sm-shift-1 justify-content-center col-lg-5 col-md-6 col-md-shift-0 col-lg-shift-1 align-items-center` }
				>
					<div className="center-vert">
						{ renderTextBlock() }
					</div>
				</div>
				<div className="col-sm-6 col-lg-4 col-md-6 col-md-shift-0 col-lg-shift-1 align-items-center">
					{ renderImgBlock() }
				</div>
			</div>
			{ inView && showScrollIkon && <ScrollIcon scrollToEl={ domRef.current.nextSibling } /> }
		</section>
	);
};

export default TekstOgBillede;
